// Renovações usam access_started_at; contas antigas usam a data de cadastro.
export const getRemainingDays = (dateString, today = new Date(), expiresAt = null) => {
  const startDate = dateString ? new Date(dateString) : new Date(today);
  const expiryDate = new Date(startDate);
  expiryDate.setDate(startDate.getDate() + 180);
  const diffDays = Math.ceil(((expiresAt ? new Date(expiresAt) : expiryDate) - today) / (1000 * 60 * 60 * 24));
  return diffDays > 0 ? diffDays : 0;
};
